import React from 'react';
import { Navigate } from 'react-router-dom';

import useAuthority from 'utils/hooks/useAuthority';
import useApproved from 'utils/hooks/useApproved';

const AuthorityGuard = props => {
	const {
		userAuthority = [],
		authority = [],
		userApproved = false,
		approved = false,
		children,
	} = props;

	const roleMatched = useAuthority(userAuthority, authority);
	const checkApproval = useApproved(userApproved, approved);

	return roleMatched && checkApproval ? (
		children
	) : (
		<Navigate to="/unauthorized" />
	);
};

export default AuthorityGuard;
